<label for="datetime-{filterObject}">Datum</label>
<input type="date" id="datetime-{filterObject}" class="h-10 inline border border-gray-200 w-full p-2 px-3 rounded focus:outline-none invalid:bg-red-50 invalid:border-red-500"
       required on:input={(e) => {onUpdateFilter(filterObject, e.target.value)}} value={filterObject.getValue()}>

<script>
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let filterObject;

    function onUpdateFilter(filterObject, value) {
        dispatch("updateFilter", {
            filterObject,
            type: "values",
            value
        });
    }
</script>